/* eslint-disable ember/classic-decorator-hooks, warp-drive/no-legacy-request-patterns */
import Service, { service } from '@ember/service';
import { findBy } from '@linc-technologies/linced-common/utils/arrays';
import { getFieldOptions } from '@linc-technologies/linced-common/utils/fields';
import InputType from '@linc-technologies/linced-common/enums/input-type';
import Scopes from '@linc-technologies/linced-common/enums/scopes';
import { set } from '@ember/object';
import { isEmpty } from '@ember/utils';

export default class FieldOptionsService extends Service {
  // Services
  @service
  permissions;

  @service
  session;

  @service
  store;

  yearLevelOptions = [];

  init() {
    super.init(...arguments);
    if (isEmpty(this.session.scopes)) {
      // default to empty options for enrolment app support.
      return;
    }

    if (!this.permissions.equal(Scopes.CAREGIVER)) {
      // If user is not a caregiver, query year level options with active school.
      this.loadYearLevels(this.session.activeSchool);
      return;
    }

    // Query year level options for all schools caregiver has access to.
    this.session.tenants.forEach((schoolId) => {
      this.loadYearLevels(schoolId);
    });
  }

  getOptions(key) {
    return getFieldOptions(key);
  }

  loadYearLevels(schoolId) {
    return this.store
      .query('people-schema/field', { key: 'core:currentYearLevel', schoolId })
      .then((fields) => {
        if (!isEmpty(fields)) {
          let yearLevelField = fields.at(0);
          if (yearLevelField.get('inputType') === InputType.SELECT) {
            let existingOptions = findBy(
              this.yearLevelOptions,
              'schoolId',
              schoolId,
            );
            let remainingOptions = isEmpty(existingOptions)
              ? this.yearLevelOptions
              : this.yearLevelOptions.filter(
                  (option) => option !== existingOptions,
                );
            set(this, 'yearLevelOptions', [
              ...remainingOptions,
              { schoolId, options: yearLevelField.get('options') },
            ]);
          }
        }
      });
  }
}
